/**
 * Back-compat shim. The real implementation now lives in
 * `src/stores/permissions.ts` as a Pinia store.
 *
 * Existing call sites do `const { canCreate, loaded } = usePermissions()`
 * and rely on `loaded.value` being a real ref. To preserve that, we
 * combine `storeToRefs` (for the reactive fields — userRoles, loaded, etc.)
 * with the actions taken straight off the store. New code should prefer
 * `usePermissionsStore()` directly.
 */
import { storeToRefs } from 'pinia'
import { usePermissionsStore } from '@/stores/permissions'

export function usePermissions() {
  const store = usePermissionsStore()
  const { userRoles, rolePermissions, loaded, loading, loadError, isAdmin, hasAnyAccess } = storeToRefs(store)
  return {
    userRoles,
    rolePermissions,
    loaded,
    loading,
    loadError,
    isAdmin,
    hasAnyAccess,
    loadPermissions: store.loadPermissions,
    resetPermissions: store.resetPermissions,
    canAccess: store.canAccess,
    canCreate: store.canCreate,
    canEdit: store.canEdit,
    canDelete: store.canDelete,
    firstAccessiblePage: store.firstAccessiblePage,
  }
}
